var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"assigned-input"},[(_vm.mounted)?_c('person-select',{staticClass:"es-simple",model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}):_vm._e(),(_vm.model)?_c('div',{staticClass:"unassign",on:{"click":_vm.unassign}},[_c('a',[_vm._v("Desatribuir")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }